import { LocationMediator } from 'shared/vidio_helpers';

export default class EmbedFluidPlayerModifier {
  static init() {
    var href = LocationMediator.href();

    if (href.indexOf('fluid_player=true') >= 0) {
      document.body.classList.add('fluid-player');
    }
  }
}
